export default __webpack_public_path__ + "static/media/visa.3883460e.svg";